import type { AxiosRequestConfig } from 'axios';

import { AbstractClient } from '../abstracts';
import { deepmergeByReference } from '../utils/deep-merge';

export class BaseClient<T extends AxiosRequestConfig = AxiosRequestConfig> extends AbstractClient<T> {
  async client<R>(options: T = Object.create(null)): Promise<R> {
    try {
      const { data } = await this.axiosInstance<R>(deepmergeByReference(this.options, options));

      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
